import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW6801Component } from './kymw6801.component';
import { GetCategoryConvInfoService } from './api-services/get-category-conv-info.service';
import { RegistCategoryConvInfoService } from './api-services/regist-category-conv-info.service';
import { UpdateCategoryConvInfoService } from './api-services/update-category-conv-info.service';
import { DeleteCategoryConvInfoService } from './api-services/delete-category-conv-info.service';

/**
 * ECカテゴリ変換マスタ画面 モジュール設定クラス
 *
 * @export KYMW6801Module
 * @class KYMW6801Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6801Component,
  ],
  providers: [
    GetCategoryConvInfoService,
    RegistCategoryConvInfoService,
    UpdateCategoryConvInfoService,
    DeleteCategoryConvInfoService,
  ],
})
export class KYMW6801Module {

}
